import { Content, ContentFolder } from "@/lib/types";
import { NodeModel } from "@minoru/react-dnd-treeview";
import { NodeModelData } from "./ContentFolderViewTypes";

export const buildTree = (folders: ContentFolder[], contents: Content[]) => {
  const items: NodeModel<NodeModelData>[] = [];

  for (const folder of folders) {
    items.push({
      id: folder.id,
      parent: folder.mainFolderId || "0",
      text: folder.name,
      droppable: true,
      data: {
        type: "folder",
        entity: folder,
      },
    });
  }

  for (const content of contents) {
    items.push({
      id: content.contentGuid,
      parent: content.folderGuid || "0",
      text: content.name,
      data: {
        type: "content",
        entity: content,
      },
    });
  }

  return items;
};
